import React from 'react';
import styled from 'styled-components';
import { Alert, Icon, Link } from 'components';

type PropertyUpdateBannerProps = { listingId: string };

const PropertyUpdateBanner: React.FC<PropertyUpdateBannerProps> = ({
  listingId,
}) => (
    <StyledAlert
      showIcon
      type="info"
      data-cy="property-update-banner"
      message={
        <>
          {'Manage property updates via the '}
          <StyledLink
            onClick={(e: any) => {
              e.stopPropagation();
            }}
            href={`/#/listing/${listingId}/view`}
            underlineOnHover
            data-cy="listing-entry-link"
          >
            {'listing details page'}
          </StyledLink>
        </>
      }
      icon={
        <Icon type="antdExclamationCircleFilled" width={15} color="primary" />
      }
    />
  );

const StyledLink = styled(Link)``;

const StyledAlert = styled(Alert)`
  margin-bottom: 10px;
`;

export default PropertyUpdateBanner;
